/*
 * Cart drawer behaviour: open/close (overlay, Escape, focus), discount codes,
 * and "often bought together" recommendations from Shopify's Product Recommendations API.
 */
(function () {
  var SECTION_SELECTOR = '#shopify-section-my-ajax-cart';
  var recommendationsCache = {};
  var pendingDiscount = null;
  var lastFocused = null;

  function drawer() {
    return document.querySelector(SECTION_SELECTOR);
  }

  function isOpen() {
    return document.body.classList.contains('js-show-ajax-cart');
  }

  function closeDrawer() {
    var section = drawer();
    if (section) section.classList.remove('active');
    document.body.classList.remove('js-show-ajax-cart');
  }

  /* ---------- Open / close ---------- */

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-overlay]')) closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) closeDrawer();
  });

  // The theme opens the drawer from several places, so follow the body class for focus handling
  new MutationObserver(function () {
    var section = drawer();
    if (!section) return;
    if (isOpen() && !section.contains(document.activeElement)) {
      lastFocused = document.activeElement;
      var dialog = section.querySelector('.my-cart');
      if (dialog) dialog.focus({ preventScroll: true });
      loadRecommendations();
    } else if (!isOpen() && section.contains(document.activeElement)) {
      if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* ---------- Recommendations ---------- */

  function cartProductIds() {
    var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    return cart && cart.items ? cart.items.map(function (item) { return String(item.product_id); }) : [];
  }

  function filterOffers(container) {
    var inCart = cartProductIds();
    var limit = Number(container.dataset.limit) || 4;
    var shown = 0;
    container.querySelectorAll('[data-cd-offer]').forEach(function (offer) {
      var hide = inCart.indexOf(offer.dataset.productId) !== -1 || shown >= limit;
      offer.hidden = hide;
      if (!hide) shown += 1;
    });
    container.hidden = shown === 0;
  }

  function renderRecommendations(container, html) {
    var list = container.querySelector('[data-cd-recommendations-list]');
    if (html !== null) list.innerHTML = html;
    filterOffers(container);
  }

  function loadRecommendations() {
    var container = document.querySelector(SECTION_SELECTOR + ' [data-cd-recommendations]');
    if (!container) return;
    if (container.dataset.source !== 'recommendations' || !container.dataset.productId) {
      filterOffers(container);
      return;
    }

    var productId = container.dataset.productId;
    if (productId in recommendationsCache) {
      renderRecommendations(container, recommendationsCache[productId]);
      return;
    }

    var url = container.dataset.url +
      '?product_id=' + encodeURIComponent(productId) +
      '&limit=' + (Number(container.dataset.limit) + 4) +
      '&section_id=cart-recommendations&intent=related';

    fetch(url)
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var list = doc.querySelector('[data-cd-recommendations-list]');
        var html = list && list.querySelector('[data-cd-offer]') ? list.innerHTML : null;
        // null keeps the collection fallback rendered by Liquid
        recommendationsCache[productId] = html;
        var current = document.querySelector(SECTION_SELECTOR + ' [data-cd-recommendations]');
        if (current && current.dataset.productId === productId) renderRecommendations(current, html);
      })
      .catch(function () {
        recommendationsCache[productId] = null;
        filterOffers(container);
      });
  }

  /* ---------- Discount codes ---------- */

  function appliedCodes() {
    var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!cart || !cart.discount_codes) return [];
    return cart.discount_codes
      .filter(function (discount) { return discount.applicable; })
      .map(function (discount) { return discount.code; });
  }

  function setDiscountMessage(text, isError) {
    var message = document.querySelector(SECTION_SELECTOR + ' [data-cd-discount-message]');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', !!isError);
  }

  function updateDiscounts(codes, pending) {
    var ajaxCart = window.liquidAjaxCart;
    if (!ajaxCart) return;
    pendingDiscount = pending;
    ajaxCart.update({ discount: codes.join(',') });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cd-discount-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = input.value.trim();
    if (!code) {
      setDiscountMessage('Enter a discount code.', true);
      return;
    }
    var codes = appliedCodes().filter(function (existing) {
      return existing.toLowerCase() !== code.toLowerCase();
    });
    codes.push(code);
    form.querySelector('button').disabled = true;
    setDiscountMessage('');
    updateDiscounts(codes, { action: 'apply', code: code });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cd-remove-discount]');
    if (!button) return;
    var code = button.getAttribute('data-cd-remove-discount');
    button.disabled = true;
    updateDiscounts(
      appliedCodes().filter(function (existing) { return existing.toLowerCase() !== code.toLowerCase(); }),
      { action: 'remove', code: code }
    );
  });

  function handleDiscountResponse(requestState) {
    var pending = pendingDiscount;
    pendingDiscount = null;
    var form = document.querySelector(SECTION_SELECTOR + ' [data-cd-discount-form]');
    if (form) form.querySelector('button').disabled = false;

    var body = requestState.responseData && requestState.responseData.body;
    if (!requestState.responseData || !requestState.responseData.ok || !body) {
      setDiscountMessage('Something went wrong. Please try again.', true);
      return;
    }
    if (pending.action === 'remove') {
      setDiscountMessage('');
      return;
    }

    var match = (body.discount_codes || []).filter(function (discount) {
      return discount.code.toLowerCase() === pending.code.toLowerCase();
    })[0];

    if (match && match.applicable) {
      if (form) form.querySelector('input[name="discount"]').value = '';
      setDiscountMessage('');
      return;
    }

    setDiscountMessage('"' + pending.code + '" can\'t be applied to your cart.', true);
    // Don't leave a code that doesn't apply sitting on the cart
    if (match) {
      updateDiscounts(
        (body.discount_codes || [])
          .filter(function (discount) { return discount.applicable; })
          .map(function (discount) { return discount.code; }),
        { action: 'remove', code: pending.code, keepMessage: true }
      );
    }
  }

  /* ---------- After every cart update ---------- */

  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var requestState = event.detail && event.detail.requestState;
    if (pendingDiscount && requestState && requestState.requestType === 'update') {
      if (pendingDiscount.keepMessage) {
        pendingDiscount = null;
      } else {
        handleDiscountResponse(requestState);
      }
    }
    loadRecommendations();
  });

  document.addEventListener('DOMContentLoaded', loadRecommendations);
})();
